import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { PureComponent } from '../component';
import Input from './Input';
import { defaultProps } from '../utils/defaultProps';
import Spin from '../Spin';
import icons from '../icons';
import { wrapSpan } from '../utils/dom/element';
import { isPromise, isFunc, isString, isEmpty } from '../utils/is';
import { isDark } from '../utils/color';
import { tagClass } from './styles';
import { isRTL } from '../config';
import getDataset from '../utils/dom/getDataset';
var hideInput = 0;
var showInput = 1;

var Tag =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Tag, _PureComponent);

  var _super = _createSuper2(Tag);

  function Tag(props) {
    var _this;

    _classCallCheck(this, Tag);

    _this = _super.call(this, props);
    _this.state = {
      dismiss: 0,
      inputVisible: hideInput,
      // tag input status
      value: null
    };
    _this.dismiss = _this.dismiss.bind(_assertThisInitialized(_this));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.handleClose = _this.handleClose.bind(_assertThisInitialized(_this));
    _this.renderClose = _this.renderClose.bind(_assertThisInitialized(_this));
    _this.closeTag = _this.closeTag.bind(_assertThisInitialized(_this));
    _this.toggleInputVisible = _this.toggleInputVisible.bind(_assertThisInitialized(_this));
    _this.inputBlur = _this.inputBlur.bind(_assertThisInitialized(_this));
    _this.inputChange = _this.inputChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Tag, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          children = _this$props.children,
          onCompleted = _this$props.onCompleted;

      if (onCompleted && isString(children) && !isEmpty(children)) {
        this.setState({
          value: children
        });
      }
    }
  }, {
    key: "closeTag",
    value: function closeTag() {
      var dismiss = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
      this.setState({
        dismiss: dismiss
      });
    }
  }, {
    key: "dismiss",
    value: function dismiss(e) {
      var _this2 = this;

      var onClose = this.props.onClose;
      var callback;

      if (onClose === true) {
        this.closeTag();
        return;
      }

      if (typeof onClose === 'function') {
        callback = onClose(e);
      }

      if (isPromise(callback)) {
        this.setState({
          dismiss: 1
        });
        callback.then(function () {
          _this2.closeTag();
        })["catch"](function () {
          _this2.closeTag(0);
        });
        return;
      }

      if (e.defaultPrevented) {
        return;
      }

      this.closeTag();
    }
  }, {
    key: "inputBlur",
    value: function inputBlur(value) {
      var onCompleted = this.props.onCompleted;
      if (isFunc(onCompleted)) onCompleted(value);
      this.setState({
        inputVisible: hideInput
      });
    }
  }, {
    key: "inputChange",
    value: function inputChange(value) {
      this.setState({
        value: value
      });
    }
  }, {
    key: "toggleInputVisible",
    value: function toggleInputVisible() {
      var _this$state = this.state,
          inputVisible = _this$state.inputVisible,
          value = _this$state.value;
      var onCompleted = this.props.onCompleted; // if onCompleted is not null

      if (onCompleted && !isEmpty(value)) {
        this.setState({
          inputVisible: inputVisible === hideInput ? showInput : hideInput
        });
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      var _this$props2 = this.props,
          onClick = _this$props2.onClick,
          disabled = _this$props2.disabled;
      if (disabled) return; // toggle input visible

      this.toggleInputVisible();

      if (typeof onClick === 'function') {
        onClick(e);
      }
    }
  }, {
    key: "handleClose",
    value: function handleClose(e) {
      var disabled = this.props.disabled;
      if (this.state.dismiss > 0 || disabled) return;
      this.dismiss(e);
    }
  }, {
    key: "renderClose",
    value: function renderClose(dismiss) {
      var onClose = this.props.onClose;
      if (!onClose) return null;
      var closeClass = tagClass('close-icon');
      var loadingClass = tagClass('close-loading');

      if (dismiss === 0) {
        return (
          /*#__PURE__*/
          React.createElement("div", {
            className: closeClass,
            onClick: this.handleClose
          }, icons.Close)
        );
      }

      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: loadingClass
        },
        /*#__PURE__*/
        React.createElement(Spin, {
          name: "ring",
          size: 10
        }))
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          dismiss = _this$state2.dismiss,
          inputVisible = _this$state2.inputVisible,
          value = _this$state2.value;
      if (dismiss === 2) return null;
      var _this$props3 = this.props,
          children = _this$props3.children,
          className = _this$props3.className,
          type = _this$props3.type,
          backgroundColor = _this$props3.backgroundColor,
          onClose = _this$props3.onClose,
          disabled = _this$props3.disabled,
          onCompleted = _this$props3.onCompleted,
          onEnterPress = _this$props3.onEnterPress,
          onKeyUp = _this$props3.onKeyUp;
      var rtl = isRTL(); // if editable and input visible

      if (onCompleted && inputVisible === showInput) return (
        /*#__PURE__*/
        React.createElement(Input, {
          value: value,
          onBlur: this.inputBlur,
          onChange: this.inputChange,
          onEnterPress: onEnterPress,
          onKeyUp: onKeyUp
        })
      );
      var childrenParsed = wrapSpan(children);
      var style = this.props.style;
      var tagClassName = tagClass('_', disabled && 'disabled', type, rtl && 'rtl');
      var inlineClassName = tagClass('inline');
      var click = !onClose ? {
        onClick: this.handleClick
      } : {};
      var tagStyle = style || {};
      if (className) tagClassName += " ".concat(className);

      if (backgroundColor) {
        tagStyle = _objectSpread2({
          color: isDark(backgroundColor) ? '#fff' : '#000',
          backgroundColor: backgroundColor,
          borderColor: 'transparent'
        }, style);
      }

      return (
        /*#__PURE__*/
        React.createElement("div", Object.assign({
          className: tagClassName,
          style: tagStyle
        }, click, getDataset(this.props)), onClose ?
        /*#__PURE__*/
        React.createElement("div", {
          onClick: this.handleClick,
          className: inlineClassName
        }, childrenParsed) : childrenParsed, this.renderClose(dismiss))
      );
    }
  }]);

  return Tag;
}(PureComponent);

Tag.defaultProps = _objectSpread2(_objectSpread2({}, defaultProps), {}, {
  type: 'default'
});
export default Tag;